<div class="layout-topbar">
  <div class="layout-topbar-logo-container" [ngClass]="{'menu-opened': isMenuOpen()}">
    <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
      <i class="pi pi-bars"></i>
    </button>
    <div class="topbar-start">
      <a routerLink="/"><img src="/assets/images/logo/new_logo.png" alt="Craftly" class="topbar-logo" /></a>
    </div>
  </div>

  <div class="layout-topbar-actions">
    <div class="topbar-menu desktop-menu">
      <button pButton type="button" label="Discover templates" class="gradient-button" [routerLink]="'/discover'">
      </button>
      <span *ngFor="let item of items" class="menu-item-root" [routerLink]="item.routerLink">{{ item.label }}</span>
    </div>
  </div>
</div>